import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent
} from "@mui/material";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SaveIcon from "@mui/icons-material/Save";
import SearchIcon from "@mui/icons-material/Search";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { getUpdateRiskList } from "../../redux/actions/updateRiskRulesAction";
import { getRulesMapping } from "../../redux/actions/rulesMappingAction";
import { IoMdSave } from "react-icons/io";
import { swalWithBootstrapButtons } from "../../utils/sweetalert";
import { getriskRuleList } from "../../redux/actions/riskRulesListAction";
import { AiOutlineSearch } from "react-icons/ai";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import { getRuleMappingCheck } from "../../redux/actions/getRuleMappingCheckAction";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import {

	getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
import Autocomplete from "@mui/lab/Autocomplete";


const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function RuleMapping() {
	var ruleIdArray = [];
	const classes = useStyles();
	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const [checkedState, setCheckedState] = useState("");

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const [show, setShow] = useState(true);

	const [getRiskRuleStatus, setGetRiskRuleStatus] = useState(false);
	const [getRiskRuleResArray, setgetRiskRuleResArray] = useState([]);
	const [rulesMappingStatus, setrulesMappingStatus] = useState(false);
	const [notificationOpen, setNotificationOpen] = useState(false);
	

	const [notificationOpen1, setNotificationOpen1] = useState(false);
	const [notificationOpen2, setNotificationOpen2] = useState(false);

	const [rulesMappingResArray, setrulesMappingResArray] = useState("");

	const [getRuleMappingCheckStatus, setGetRuleMappingCheckStatus] =
		useState(false);
	const [getRuleMappingCheckArray, setGetRuleMappingCheckArray] = useState([]);
	const [blockIDS, setBlockIDS] = useState({
		blockId: []
	});
	const [merchantId, setMerchantId] = useState("");
	// const [user, setUser] = useState({
	// 	merchantID: ""
	// });
	const [isLoading, setIsLoading] = useState(false);
	// const { merchantID } = user;
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);

	const getRuleMappingCheckRes = useSelector(
		({ getRuleMappingCheck }) => getRuleMappingCheck
	);

	const handleChange = ({ target: { name, value } }) => {
	

		if (name === "merchantId") {
			// console.log("merchantId", merchantId)
			setMerchantId(value)
		}
	}

	const getRuleMappingCheckReq = () => {

		setGetRuleMappingCheckStatus(true);
		let req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			terminalVO: {
				merchantId: merchantId.split("-")[0] || ""
			}
		};
		dispatch(getRuleMappingCheck(req, authToken));
	};

	const getRuleMappingCheckFunc = () => {
		if (getRuleMappingCheckStatus) {
			if (getRuleMappingCheckRes.data.status == "success") {
				setGetRuleMappingCheckArray(getRuleMappingCheckRes.data);
				// setBlockIDS({
				//   blockId: getRuleMappingCheckRes.data.checkedIdList.map((x) => x.ruleId),
				// });
				setBlockIDS({
					blockId: [
						...new Set(
							[]
								.concat(getRuleMappingCheckRes.data.checkedIdList)
								.map((item) => item.ruleId)
						)
					]
				});
				// [...new Set(getRuleMappingCheckRes.data.checkedIdList.map(item => item.ruleId))]
			}
			if (getRuleMappingCheckRes.data.status == "failed") {
				setNotificationOpen(true);
				setGetRuleMappingCheckArray(getRuleMappingCheckRes.data);
				if (
					getRuleMappingCheckRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getRuleMappingCheckRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getRuleMappingCheckRes.data.status == "Failed") {
				setGetRuleMappingCheckArray(getRuleMappingCheckRes.data);
				if (
					getRuleMappingCheckRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getRuleMappingCheckRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getRuleMappingCheckFunc();
	}, [getRuleMappingCheckRes.data.status]);

	useEffect(() => {
		// console.log(blockIDS.blockId, "////////////////////");
	}, [blockIDS]);

	const onCheck = (id, e) => {
		const { value, checked } = e.target;
		const { blockId } = blockIDS;
		if (checked) {
			setBlockIDS({
				blockId: [...blockId, id]
			});
		} else {
			setBlockIDS({
				blockId: blockId.filter((e) => e !== id)
			});
		}
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			// getRuleMappingCheckReq();
		}
	}, [regenerateTokenRes.data.status]);

	// const onInputChange = ({ target: { name, value } }, type) => {
	// 	// setUser({ ...user, [e.target.name]: e.target.value });
	// 	const obj = {
	// 		...user
	// 	};

	// 	if (type == "number") {
	// 		obj[name] = Util.verifyMobile(value) ? value : obj[name];
	// 	} else if (type == "alphabet") {
	// 		obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
	// 	} else if (type == "both") {
	// 		obj[name] = Util.alphaNumeric(value) ? value : obj[name];
	// 	} else if (type == "url") {
	// 		obj[name] = Util.verifyUrl(value) ? value : obj[name];
	// 	} else {
	// 		// obj[name] = value.trim()
	// 		obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
	// 	}
	// 	setUser(obj);
	// };

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};
	const handleNoticationClose = () => {
		if (notificationOpen1) {
			setNotificationOpen1(false);
			
		} else {
			setNotificationOpen(false);
			getAllWalletsListApi();
			setTotal("");
		}
	};
	// const handleNoticationClose2 = () => {
	// 	if (notificationOpen2) {
			
	// 		setNotificationOpen2(false)
	// 	} else {
	// 		setNotificationOpen(false);
	// 		getAllWalletsListApi();
	// 		setTotal("");
	// 	}
	// };

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const getAllWalletsListApi = () => {
		// console.log("MERCHANTID",merchantId)
		if (merchantId == "") {
			setNotificationOpen1(true);
			
			setGetRiskRuleStatus(false);
		}
	
		else {
			setIsLoading(true);
			setGetRiskRuleStatus(true);
			setShow(false);
			const getAllWalletsListReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					// ruleId: "",
					// riskGroup: "",
					// ruleStatus: "",
					customerId: merchantId.split("-")[0] || ""
				}
			};
			// console.log("getAllWalletsListApisss",getAllWalletsListReq)

			return dispatch(getriskRuleList(getAllWalletsListReq, authToken));
		}
	};

	const getAllWalletsListRes = useSelector(
		({ riskRulesList }) => riskRulesList
	);
	// console.log("getAllWalletsListRes", getAllWalletsListRes);
	// console.log("getAllWalletsListRes", getAllWalletsListRes);

	const getRiskRuleStatusFunc = () => {
		if (getRiskRuleStatus) {
			setIsLoading(false);
			if (getAllWalletsListRes.data.status == "Success") {
				ruleIdArray = [];
				setgetRiskRuleResArray(
					[].concat(getAllWalletsListRes.data.riskRuleList)
				);
				setCheckedState(
					new Array(
						[].concat(getAllWalletsListRes.data.riskRuleList).length
					).fill(false)
				);
				getRuleMappingCheckReq();
			}
			if (getAllWalletsListRes.data.status == "Failed") {
				ruleIdArray = [];
				setNotificationOpen(true);
				setgetRiskRuleResArray(getAllWalletsListRes.data);
				if (
					getAllWalletsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getAllWalletsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	var obj = getRiskRuleResArray;

	const getCurrIdx = (idx, value) => {
		obj[idx].ruleStatus = value;
		// console.log(getRiskRuleResArray, "obj");
		setgetRiskRuleResArray([]);
		setgetRiskRuleResArray([].concat(obj));
	};

	useEffect(() => {
		if (getRiskRuleStatus) {
			getRiskRuleStatusFunc();
		}
	}, [getAllWalletsListRes.data.status]);


	// riskScore

	// var riskScore =
	//   getAllWalletsListRes.success &&
	//   getAllWalletsListRes.data.riskRuleList &&
	//   [].concat(getAllWalletsListRes.data.riskRuleList).map((row, index) => {
	//     return row.riskScore;
	//   });

	// console.log("riskScore", riskScore);

	// ruleId

	// var ruleId =
	//   getAllWalletsListRes.success &&
	//   getAllWalletsListRes.data.riskRuleList &&
	//   [].concat(getAllWalletsListRes.data.riskRuleList).map((row, index) => {
	//     return row.ruleId;
	//   });

	// console.log("ruleId", ruleId);

	// ruleName

	// var ruleName =
	//   getAllWalletsListRes.success &&
	//   getAllWalletsListRes.data.riskRuleList &&
	//   [].concat(getAllWalletsListRes.data.riskRuleList).map((row, index) => {
	//     return row.ruleName;
	//   });
	// console.log("ruleName", ruleName);

	// var ruleStatus =
	//   getAllWalletsListRes.success &&
	//   getAllWalletsListRes.data.riskRuleList &&
	//   [].concat(getAllWalletsListRes.data.riskRuleList).map((row, index) => {
	//     return row.ruleStatus;
	//   });

	// console.log("ruleStatus", ruleStatus);

	// ruleMapping

	const ruleMapping = (merchantID) => {
		// setShow(false);
		setrulesMappingStatus(true);
		const Req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				action: "CREATE",
				customerId: merchantID.split("-")[0] || ""
			},
			riskRuleList: blockIDS.blockId.map((x) =>
				getRiskRuleResArray.find((y) => y.ruleId == x)
			)
			// riskRuleList: total,

			// [
			//   {
			//     riskScore: riskScore,
			//     ruleId: ruleId,
			//     ruleName: ruleName,
			//     ruleStatus: ruleStatus,
			//   },
			// ],
		};

		return dispatch(getRulesMapping(Req, authToken));
	};

	// if (rulesMappingg.success) {
	//   swalWithBootstrapButtons.fire({
	//     type: "success",
	//     title: "Record Udated SuccessFully",
	//   });
	// }

	//const rulesMapping = useSelector(({ rulesMapping }) => rulesMapping);
	//console.log("rulesMapping", rulesMapping);

	// getupdateRiskRule

	// const getupdateRiskRule = () => {
	//   const Req = {
	//     loginDetails: {
	//       walletOwnerId: regenerateTokenRes.data.partnerId || "",
	//     },
	//     riskRuleList: [
	//       {
	//         limit: "0.00",
	//         riskScore: "13",
	//         ruleId: "3",
	//         ruleName: "test1",
	//         ruleStatus: "Y",
	//       },
	//       {
	//         limit: "0.00",
	//         riskScore: "14",
	//         ruleId: "1",
	//         ruleName: "test",
	//         ruleStatus: "Y",
	//       },
	//     ],
	//   };
	//   if (updateRiskRule.success) {
	//     swalWithBootstrapButtons.fire({
	//       type: "success",
	//       title: "Record Udated SuccessFully",
	//     });
	//   }

	//   return dispatch(getUpdateRiskList(Req, authToken));
	// };

	const updateRiskRule = useSelector(({ updateRiskRule }) => updateRiskRule);
	// console.log("updateRiskRule", updateRiskRule);

	const rulesMappinggRes = useSelector(({ rulesMapping }) => rulesMapping);

	// console.log("rulesMappinggRes", rulesMappinggRes);

	useEffect(() => {
		 if (rulesMappingStatus) {
		rulesMappinggFunc();
		}
	}, [rulesMappinggRes.data.status]);

	const rulesMappinggFunc = () => {
		if (rulesMappingStatus) {
			if (rulesMappinggRes.data.status == "success") {
				setNotificationOpen(true);
				setrulesMappingResArray(rulesMappinggRes.data);
			}
			if (rulesMappinggRes.data.status == "failed") {
				setNotificationOpen(true);
				setrulesMappingResArray(rulesMappinggRes.data);
				if (
					rulesMappinggRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					rulesMappinggRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (rulesMappinggRes.data.status == "Failed") {
				setNotificationOpen(true);
				setrulesMappingResArray(rulesMappinggRes.data);
				if (
					rulesMappinggRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					rulesMappinggRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const handlefeeChargesFn = (idx, valueScore, nameScore) => {
		if (nameScore == "riskScore") {
			obj[idx].riskScore = valueScore;
			setrulesMappingResArray([]);
			setrulesMappingResArray([].concat(obj));
		}
	};

	// const handleChange = (ruleId, e) => {
	//   getRiskRuleResArray.map((item) => {
	//     if (item.ruleId == ruleId) {
	//       ruleIdArray.push(item);
	//       console.log(ruleIdArray);
	//     }
	//   });
	// };

	const [total, setTotal] = useState("");
	var totalCheckboxArray = [];

	const handleOnChange = (position) => {
		const updatedCheckedState = checkedState.map((item, index) =>
			index === position ? !item : item
		);

		setCheckedState(updatedCheckedState);

		const totalPrice = updatedCheckedState.reduce(
			(sum, currentState, index) => {
				if (currentState === true) {
					return totalCheckboxArray.push(getRiskRuleResArray[index]);
				}
				if (currentState === false) {
					return totalCheckboxArray.splice(index);
				}
			},
			totalCheckboxArray
		);
		setTotal(totalCheckboxArray);
	};

	useEffect(() => {
		if (getCustomerIdAndNameListRes.data.status === "Success") {
			// console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
		}
	}, [getCustomerIdAndNameListRes.data.status])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);

	const filterOptionsL = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={1}
						style={{ padding: "20px", marginTop: "1rem" }}
					>
						<Grid item className="mb-3" xs={12} sm={12} md={5} lg={5}>
							{/* <TextField
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Merchant ID*"
								variant="standard"
								// variant="outlined"
								fullWidth={true}
								name="merchantID"
								value={merchantID}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "number")}
							/> */}
									<Autocomplete
									id="combo-box-demo"
									options={[].concat(
										getCustomerIdAndNameListRes.data.currencyList || [""]
									)}
									getOptionLabel={(option) => option}
									filterOptions={filterOptionsL}
									value={merchantId}
									onChange={handleChange}
									onInputChange={(event, newInputValue) => {
										setMerchantId(newInputValue);
									}}
									renderInput={(params) => (
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="Merchant ID"
											style={{ marginTop: "3px" }}
											// required
											type="tel"
											fullWidth
											{...params}
											// value={merchantID}
											name="merchantID"
											// onChange={(e) => onInputChange(e, "number")}

											variant="standard"
											sx={{
												"& .MuiInput-underline:before": {
												  borderBottomColor: "gray", // White color for the underline before focus
												},
												"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
												  borderBottomColor: "gray", // White color on hover
												},
												"& .MuiInput-underline:after": {
												  borderBottomColor: "gray", // White color after focus
												},
											  }}
										/>
									)}
								/>
						</Grid>
						<Grid item xs={12} sm={12} md={2} lg={2}>
							{/* <Button
                style={{
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                className="riskRuleButton"
                onClick={getAllWalletsListApi}
              >
                Search
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getAllWalletsListApi}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
						<Grid item sm={12} md={5} lg={5}></Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getRiskRuleResArray.length == undefined || !getRiskRuleStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Risk Rules
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
									// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Risk Rules
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Rule ID{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Rule Name{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Risk Group
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Score
											</TableCell>
											{/* <TableCell align="center">Limit</TableCell> */}
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Status
											</TableCell>
											{/* <TableCell align="center">Action</TableCell> */}
										</TableRow>
									</TableHead>

									<TableBody>
										{getRiskRuleResArray &&
											[]
												.concat(getRiskRuleResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={index}>
														<TableCell align="center">
															<input
																type="checkbox"
																value={row.ruleId}
																// onChange={(e) => handleChange(row.ruleId, e)}
																id={`custom-checkbox-${index}`}
																checked={blockIDS.blockId.includes(row.ruleId)}
																// checked={checkedState[index]}
																// onChange={() => handleOnChange(index)}
																onClick={(e) => onCheck(row.ruleId, e)}
															/>
														</TableCell>
														<TableCell align="center">{row.ruleId}</TableCell>
														<TableCell align="center">{row.ruleName}</TableCell>
														<TableCell align="center">
															{row.riskGroup}
														</TableCell>
														<TableCell align="center">
															<TextField
																type="number"
																value={row.riskScore}
																size="small"
																color="primary"
																// autoFocus={true}
																variant="outlined"
																fullWidth={true}
																onChange={({ target: { value } }) =>{
																	const newScore = parseInt(value);
																    if(newScore >=0 || value ===''){
																	  handlefeeChargesFn(index, value, "riskScore")
																	}
																}}
															>
																{/* {row.riskScore} */}
															</TextField>
														</TableCell>
														{/* <TableCell align="center">
                          <TextField
                            value={row.min_transaction_amount}
                            size="small"
                            color="primary"
                            autoFocus={true}
                            variant="outlined"
                            fullWidth={true}
                          >
                            {row.min_transaction_amount}
                          </TextField>
                        </TableCell> */}
														<TableCell align="center">
															<TextField
																select
																size="small"
																color="primary"
																// autoFocus={true}
																// label="role"
																variant="outlined"
																fullWidth={true}
																name="role"
																value={row.ruleStatus}
																// value={role}
																// onChange={(e) => onInputChange(e)}
															>
																<MenuItem
																	onClick={() => getCurrIdx(index, "Y")}
																	value={"Y"}
																>
																	Enable
																</MenuItem>
																<MenuItem
																	onClick={() => getCurrIdx(index, "N")}
																	value={"N"}
																>
																	Disable
																</MenuItem>
															</TextField>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>

								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={
										[].concat(getAllWalletsListRes.data.riskRuleList).length
									}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
								<Grid container>
									<Grid item md={5} lg={5}></Grid>
									<Grid item md={2} lg={2}>
										{/* <Button
											variant="contained"
											style={{
												backgroundColor: "#00b9f5",
												color: "white"
											}}
											size="small"
											className="my-2"
											endIcon={<IoMdSave />}
											onClick={() => ruleMapping(merchantID)}
										>
											Save
										</Button> */}
										<CustomButton
											style={{
												padding: "8px"
											}}
											// onClick={getRiskRuleListApi}
											onClick={() => ruleMapping(merchantId)}
										>
											Save <SaveIcon />
										</CustomButton>
									</Grid>
									<Grid item md={5} lg={5}></Grid>
								</Grid>
							</TableContainer>
						</Grid>
					</Card>
				)}
			</Layout>

			{rulesMappingResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								{rulesMappingResArray.description}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{rulesMappinggRes.data.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
							>
								{rulesMappinggRes.data.description}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{rulesMappingResArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
							>
								{rulesMappingResArray.description}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{notificationOpen1 && (
				<div>
					<Dialog open={notificationOpen1} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
							>
								Please Select Merchant Id for Search.
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
{/* 
{notificationOpen2 && (
				<div>
					<Dialog open={notificationOpen2} onClose={handleNoticationClose2}>
						<DialogContent
							className="text-center lightThemeBackground"
							// style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
							>
								Please Select Valid Member ID
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose2}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)} */}
		</>
	);
}

export default RuleMapping;
